export default "__VITE_ASSET__C7sR1BAF__"